var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ListConfigBase } from '../list-config-base';
/**
 * A config containing properties for list view
 */
var ListConfig = /** @class */ (function (_super) {
    __extends(ListConfig, _super);
    function ListConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ListConfig;
}(ListConfigBase));
export { ListConfig };
//# sourceMappingURL=list-config.js.map